import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ProfileDefaultImage from '../../../../images/profileDefault.png';
import StarIcon from '../../../../images/star_Green.png';
import CrossImage from '../../../../images/close-cross.png';
import { Colors } from '../../../../themes/colors';

export const OfficePreview = ({ office, onRemove }) => {
  const address = useMemo(() => {
    if (!office?.address?.length || !office?.address[0]?.formatted_address) {
      return '';
    }
    const addressParts = office.address[0].formatted_address.split(', ');
    return `${addressParts[1]}, ${addressParts[2]}`;
  }, [office]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {office?.profileImage ? (
        <img
          src={office.profileImage}
          alt="profile"
          className="card-img-top mt-2 mb-2"
          style={{
            objectFit: 'cover',
            width: '100px',
            height: '100px',
            borderRadius: 50,
            boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
          }}
        />
      ) : (
        <img
          src={ProfileDefaultImage}
          alt="tooth"
          className="card-img-top mt-2 mb-2"
          style={{
            objectFit: 'cover',
            width: '100px',
            height: '100px',
            borderRadius: 50,
            boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
          }}
        />
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: 10,
        }}
      >
        <strong className="card-title" style={{ textAlign: 'center', color: Colors.primary_500 }}>
          DENTIST
        </strong>

        <h4
          style={{
            textAlign: 'center',
          }}
        >
          {office?.officeName}
        </h4>

        {office?.averageRating ? (
          <div
            height="34px"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'baseline',
              marginTop: 10,
            }}
          >
            <img
              src={StarIcon}
              className="card-img-left"
              width="15px"
              alt="star_icon"
              style={{ marginBottom: 10 }}
            />
            <p className="card-text">{office?.averageRating?.toFixed(1) || '-'}</p>
          </div>
        ) : (
          <div style={{ height: 34 }} />
        )}
        <p className="card-text">{address}</p>
        <Link
          className="card-text"
          to={{
            pathname: `/user/dentist/${office?.id}`,
            state: {
              user_id: office?.id,
              profile: 'DENTIST',
            },
          }}
        >
          View Profile
        </Link>
        {onRemove && (
          <img alt="icon" src={CrossImage} style={{ width: 16, height: 16 }} onClick={onRemove} />
        )}
      </div>
    </div>
  );
};
